import React from 'react';
import { Modal } from 'antd';
import { AdPreview } from './AdPreview';

interface AdPreviewModalProps {
    visible: boolean;
    onClose: () => void;
    adData: {
        adCreativeMessage: string;
        adCreativeImageLink: string;
        adCreativeLinkName: string;
        adCreativeLinkMessage: string;
        adName: string;
    } | null;
}

const AdPreviewModal: React.FC<AdPreviewModalProps> = ({ visible, onClose, adData }) => {
    if (!adData) return null;

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width={400}
            style={{ zIndex: 1200 }}
        >
            <AdPreview
                primaryText={adData.adCreativeMessage}
                headline={adData.adCreativeLinkName}
                descriptionText={adData.adCreativeLinkMessage}
                mediaUrl={adData.adCreativeImageLink}
                facebookPage={adData.adName}
            />
        </Modal>
    );
};

export default AdPreviewModal;
